/* eslint no-console: "off", quotes: "off" */
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import Maintenance from '@/components/home/modals/shared/Maintenance';
import NoBalanceModal from '../../components/home/modals/NoBalanceModal';
import DeclinedRequest from '../../components/home/game/challenge/DeclinedRequest';
import PendingChallenge from '../../components/home/game/challenge/PendingChallenge';
import CelebrityProcessExpired from "../../components/home/game/challenge/CelebrityProcessExpired";

const RequestForRematch = {
  methods: {
    ...mapActions('game', [
      'matchingWithUser',
    ]),
    ...mapMutations('users', [
      'setDeclinedReason',
    ]),
    ...mapMutations('game', [
      'updateChallengeInfo',
      'updateValidRedirectionToPendingRequestPage',
    ]),
    ...mapMutations('common', [
      'storeModalForChallenge',
      'storeModalForHomePage',
    ]),
    requestRematch(username, rematchedGameChoice, stickerUserChoice, playWithCelebrity) {
      const payload = {
        opponentUsername: username,
        rematchedGame: rematchedGameChoice,
        duelId: (rematchedGameChoice) ? this.gameID : null,
        stickerChoice: stickerUserChoice,
        playWithCelebrityChoice: playWithCelebrity,
      };
      this.matchingWithUser(payload).then((response) => {
        console.log(response);
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          this.updateValidRedirectionToPendingRequestPage(true);
          this.storeModalForChallenge(null);
          if (response.data.data.challengeDTOEnum === 'REMATCH_WITH_BOT') {
            console.log('REMATCH WITH BOT, NOTIFICATION DATA WILL HANDLE IT');
          } else if (response.data.data.challengeDTOEnum === 'REMATCH_GAME' || response.data.data.challengeDTOEnum === 'NO_REMATCH_GAME') {
            this.$router.push({ name: 'pendingRequest' });
            this.storeModalForHomePage(null); // close everything
            this.updateChallengeInfo({
              challengedLevel: response.data.data.challengedUser.userLevel,
              challengingLevel: response.data.data.challengingUser.userLevel,
              challengedMsisdn: response.data.data.challengedUser.msisdn,
              challengingMsisdn: response.data.data.challengingUser.msisdn,
              challengedUsername: response.data.data.challengedUser.username,
              challengingUsername: response.data.data.challengingUser.username,
              challengedAvatar: response.data.data.challengedUser.avatar,
              challengingAvatar: response.data.data.challengingUser.avatar,
            });
          } else if (response.data.data.challengeDTOEnum === 'PENDING_CHALLENGE_EXISTS') {
            this.storeModalForChallenge(PendingChallenge);
          }
        }
        if (response.data.responseEnum === 'NO_AVAILABLE_GAMES') {
          this.storeModalForChallenge(NoBalanceModal);
        } else if (['PROCESS_ALREADY_HAS_STARTED_PLEASE_WAIT', 'PENDING_GAME_EXISTS'].includes(response.data.responseEnum)) {
          this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_opponent_already_play_games);
          this.storeModalForChallenge(DeclinedRequest);
        } else if (response.data.responseEnum === 'OPPONENT_IS_NOT_ACTIVE') {
          this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_opponent_offline);
          this.storeModalForChallenge(DeclinedRequest);
        } else if (response.data.responseEnum === 'USER_BLOCKED_BY_OPPONENT') {
          this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_opponent_blocked_you);
          this.storeModalForChallenge(DeclinedRequest);
        } else if (response.data.responseEnum === 'OPPONENT_HAS_NOT_ENOUGH_BALANCE') {
          this.setDeclinedReason(this.getTranslations.home_rematch_generic_msg_opponent_no_available_games);
          this.storeModalForChallenge(DeclinedRequest);
        } else if (response.data.responseEnum === 'CELEBRITY_PROCESS_EXPIRED') {
          this.storeModalForChallenge(CelebrityProcessExpired);
        } else if (response.data.responseEnum === 'SERVER_ERROR') {
          this.storeModalForChallenge(Maintenance);
        }
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameID',
    ]),
  },
};

export default RequestForRematch;



// WEBPACK FOOTER //
// ./src/common/mixins/extraRematchInfo.js